/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

const Error = ({ statusCode }) => {
  return (
    <div className="w-10/12 md:8/12 container mx-auto py-4 md:py-8 lg:py-12 text-center flex flex-col justify-center min-h-screen">
      <h1 className="text-6xl lg:text-50 leading-32 lg:leading-52 text-white">{statusCode}</h1>
      <p className="text-2xl lg:text-3xl leading-9 py-8">Oeps, je bent te diep gezwommen! Er is iets mis gegaan.</p>
    </div>
  );
};

Error.getInitialProps = ({ res, err }) => {
  let statusCode = 404;
  if (res) {
    statusCode = res.statusCode;
    return { statusCode };
  }
  if (err) {
    statusCode = err.statusCode;
    return { statusCode };
  }
  return { statusCode };
};

Error.propTypes = {
  statusCode: PropTypes.string.isRequired,
};

export default Error;
